/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import * as moment from 'moment';

import { UserContext } from '../../context';


const RelatedSegmentsListVertical = (props) => {
  const handleResize = () => {
    const videoHeight = document.getElementById('vp_18_wrapper').offsetHeight;
    document.getElementById('related-vertical-wrapper').style.maxHeight =
      `${videoHeight}px`;
  };

  useEffect(() => {
    if (!isMobile) {
      window.addEventListener('resize', handleResize);
      handleResize();

      return () => window.removeEventListener('resize', handleResize);
    }
  }, [handleResize]);

  const formatDate = (date) => {
    const d = new Date(date);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) {
      month = `0${month}`;
    }
    if (day.length < 2) {
      day = `0${day}`;
    }

    return [year, month, day].join('/');
  };

  const getDayOfWeek = (date) => {
    const dayNum = new moment(date).utc().day();
    switch (dayNum) {
      case 0:
        return 'Sunday';
      case 1:
        return 'Monday';
      case 2:
        return 'Tuesday';
      case 3:
        return 'Wednesday';
      case 4:
        return 'Thursday';
      case 5:
        return 'Friday';
      case 6:
        return 'Saturday';
      default:
        break;
    }
  };

  const getTitleDate = () => {
    const { programSegments, currentPosition, program } = props;
    if (programSegments[currentPosition]) {
      const timestamp = program.title ? program.title : program.programDate ? program.programDate : program.publishedAt;
      const day = getDayOfWeek(timestamp);
      const date = moment(timestamp).
        utc().
        format('LL');

      return `${day} ${date}`;
    }
    if (programSegments.segment) {
      return (
        programSegments.anchors[0] &&
        `${programSegments.anchors[0].name} in ${programSegments.segment.name}`
      );
    }
  };

  const { changeVideoSrc, programSegments, currentPosition, openSubscriptionModal, program } = props;

  return (
    <>
      <div
        className={`related-vertical-wrapper ${isMobile &&
        'related-mobile-wrapper'}`}
        id="related-vertical-wrapper"
      >
        {isMobile && !props.isPromoActive && (
          <div className="player-title-name">
            <h3>{programSegments[currentPosition].segment.name !== '' ? programSegments[currentPosition].segment.name : program.nextSegmentCategory}</h3>
            <p>{getTitleDate()}</p>
          </div>
        )}

        {programSegments.length &&
        programSegments.map((programSegment, index) => (
          <div
            key={index}
            className={`related-vertical-item ${index === currentPosition &&
                'now-playing-wrapper'}`}
          >
            <a
              className="related-img-wrapper"
              href={'#'}
              onClick={() => changeVideoSrc(programSegment, index)}
            >
              <img
                alt={programSegment.segment.name !== '' ? programSegment.segment.name : program.nextSegmentCategory}
                className="related-img"
                src={programSegment.clip && programSegment.clip.thumbnailImageUrl ? programSegment.clip.thumbnailImageUrl : program.clip.thumbnailImageUrl}
              />
              {index === currentPosition && (
                <div className="related-now-playing">
                  <p>NOW PLAYING</p>
                </div>
              )}
            </a>
            <a
              className="white related-vertical-link"
              href={'#'}
              onClick={(e) => changeVideoSrc(programSegment, index)}
            >
              {programSegment.segment.name !== '' ? programSegment.segment.name : program.nextSegmentCategory}
            </a>
          </div>
        ))}

        <UserContext.Consumer>
          {(value) =>
            isMobile &&
          value.user &&
          !value.user.activeSubscription && (
          <div className="subscribe-btn-wrapper subscribe-btn-wrapper-mobile">
                <button className="subscribe-btn" onClick={openSubscriptionModal}>
              SUBSCRIBE
                </button>
              </div>
            )
          }
        </UserContext.Consumer>
      </div>
      {props.isPromoActive ? <div className="promo-player-title-name">
        <h3>{programSegments[currentPosition].segment.name !== '' ? programSegments[currentPosition].segment.name : program.nextSegmentCategory}</h3>
        <p>{getTitleDate()}</p>
      </div> : ''}
    </>
  );
};

export default RelatedSegmentsListVertical;
